import { render, staticRenderFns } from "./BlockGallery.vue?vue&type=template&id=0e6e3da0&"
import script from "./BlockGallery.vue?vue&type=script&lang=js&"
export * from "./BlockGallery.vue?vue&type=script&lang=js&"
import style0 from "./BlockGallery.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports